<template>
  <div>
    <b-modal
      id="modal-quote-lang"
      centered
      hide-header
      hide-footer
      body-class="p-0"
      :visible="visible && !lang"
      @hide="onLangModalHide"
    >
      <div class="quote-lang-modal">
        <div class="quote-lang-header">CHỌN LOẠI BÁO GIÁ</div>
        <div class="quote-lang-body">
          <p class="quote-lang-question">
            Bạn muốn tạo báo giá bằng ngôn ngữ nào?
          </p>
          <div class="quote-lang-options">
            <button
              v-for="option in langOptions"
              :key="option.value"
              type="button"
              class="quote-lang-option"
              @click="selectLang(option.value)"
            >
              <span class="quote-lang-code">{{ option.code }}</span>
              <span class="quote-lang-label">{{ option.label }}</span>
              <span class="quote-lang-hint">{{ option.hint }}</span>
            </button>
          </div>
        </div>
        <div class="quote-lang-footer">
          <button type="button" class="clear-btn" @click="$emit('close')">
            Hủy
          </button>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="modal-bulk-edit-quote"
      ref="modalBulkEditQuote"
      size="xl"
      hide-header
      hide-footer
      body-class="p-0"
      dialog-class="quote-edit-dialog"
      :visible="visible && !!lang"
      @hide="$emit('close')"
    >
      <div class="quote-modal-header">
        <span>{{ t.modalTitle }}</span>
        <button
          type="button"
          class="quote-modal-close"
          aria-label="Đóng"
          @click="cancelEdit"
        >
          &times;
        </button>
      </div>
      <div class="bulk-edit-quote-modal">
        <div class="d-flex flex-row align-items-stretch" style="width: 100%">
          <div class="table-responsive flex-grow-1" ref="pdfContent">
            <!-- Header Section -->
            <div
              class="quote-image-page"
              style="position: relative"
              ref="headerSection"
            >
              <img
                :src="images.header"
                alt="Header"
                style="
                  height: 100%;
                  width: auto;
                  display: block;
                  margin: 0 auto;
                "
              />
              <div class="header-content-bg">
                <div class="header-content">
                  <div
                    ref="coverTitle"
                    class="title-header"
                    :style="{ fontSize: coverTitleSize + 'px' }"
                  >
                    <span>{{ t.coverTitleLine1 }}</span>
                    <span v-if="t.coverTitleLine2">{{
                      t.coverTitleLine2
                    }}</span>
                  </div>
                  <template v-if="isSubmitted">
                    <div class="header-abs-input header-abs-input-1">
                      {{ headerInput1 }}
                    </div>
                    <div class="header-abs-input header-abs-input-2">
                      {{ headerInput2 }}
                    </div>
                  </template>
                  <template v-else>
                    <textarea
                      v-model="headerInput1"
                      class="header-abs-input header-abs-input-1"
                      :rows="headerInput1.includes('\n') ? 2 : 1"
                      :placeholder="t.recipientPlaceholder"
                      @input="onHeaderInput1Input"
                      style="resize: none; overflow: hidden"
                    />
                    <input
                      v-model="headerInput2"
                      class="header-abs-input header-abs-input-2"
                      type="text"
                      :placeholder="t.datePlaceholder"
                    />
                  </template>
                </div>
              </div>
              <!-- one stacked block: longer texts (e.g. the english address)
                   push it up instead of overlapping the lines above -->
              <div class="cover-contact" :class="{ editing: !isSubmitted }">
                <template v-if="isSubmitted">
                  <div class="cover-contact-name">{{ headerInput3 }}</div>
                  <div class="cover-contact-dept">{{ headerInput4 }}</div>
                </template>
                <template v-else>
                  <input
                    v-model="headerInput3"
                    class="cover-contact-name"
                    type="text"
                  />
                  <input
                    v-model="headerInput4"
                    class="cover-contact-dept"
                    type="text"
                  />
                </template>
                <div
                  v-for="field in coverContactFields"
                  :key="field.key"
                  class="cover-contact-row"
                  :class="{ 'red-input': field.red }"
                >
                  <img :src="field.icon" :alt="field.key" />
                  <span v-if="isSubmitted">{{ $data[field.key] }}</span>
                  <input
                    v-else
                    :value="$data[field.key]"
                    type="text"
                    :placeholder="t[field.placeholder]"
                    @input="$data[field.key] = $event.target.value"
                  />
                </div>
              </div>
            </div>
            <!-- Product Tables -->
            <div
              v-for="(productGroup, groupIdx) in productGroups"
              :key="'group-' + groupIdx"
              class="quote-table-product"
              :ref="'listTable-' + groupIdx"
            >
              <table
                :ref="'editableTable-' + groupIdx"
                class="table table-bordered table-editable mb-0"
              >
                <thead>
                  <tr>
                    <th style="width: 150px">{{ t.stt }}</th>
                    <th
                      v-for="col in 5"
                      :key="'header-' + groupIdx + '-' + col"
                    >
                      {{ groupIdx * 5 + col }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="product-image">
                    <td>{{ t.image }}</td>
                    <td
                      v-for="(product, idx) in productGroup"
                      :key="'img-' + groupIdx + '-' + idx"
                    >
                      <template v-if="product">
                        <div
                          style="
                            width: 100%;
                            height: 100%;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                          "
                        >
                          <img
                            :src="getProductImage(product)"
                            alt="Ảnh sản phẩm"
                            style="
                              max-height: 100%;
                              max-width: 100%;
                              object-fit: contain;
                              display: block;
                            "
                          />
                        </div>
                      </template>
                    </td>
                  </tr>
                  <tr
                    v-for="row in visibleRows"
                    :key="row.key"
                    :class="[
                      row.lines === 2 ? 'two-line-row' : 'one-line-row',
                      { 'high-light': row.highlight },
                    ]"
                  >
                    <td>
                      <img
                        src="@/assets/images/remove.png"
                        class="remove-btn"
                        alt="Xoá hàng"
                        v-if="!isSubmitted"
                        @click="removeTableRow(row.key)"
                      />{{ t.rows[row.label] }}
                      <span v-if="t.units[row.unit]" class="text-hint">{{
                        t.units[row.unit]
                      }}</span>
                    </td>
                    <td
                      v-for="(product, idx) in productGroup"
                      :key="row.key + '-' + groupIdx + '-' + idx"
                      :class="row.cellClass"
                    >
                      <template v-if="product">
                        <span
                          v-if="!isEditing(row.key, groupIdx, idx)"
                          @click="startEdit(row.key, groupIdx, idx)"
                          class="editable-span"
                          :class="[
                            row.spanClass,
                            {
                              'quote-cell-untranslated': isUntranslated(
                                row,
                                cellCtx(product, groupIdx, idx)
                              ),
                            },
                          ]"
                          :style="row.bold ? 'font-weight: bold' : ''"
                        >
                          {{ row.display(cellCtx(product, groupIdx, idx)) }}
                        </span>
                        <input
                          v-else
                          :value="row.getInput(cellCtx(product, groupIdx, idx))"
                          class="form-control"
                          @input="
                            row.setInput(
                              cellCtx(product, groupIdx, idx),
                              $event.target.value
                            )
                          "
                          @blur="commitEdit(row, groupIdx, idx)"
                          @keyup.enter="commitEdit(row, groupIdx, idx)"
                          :ref="'input-' + row.key + '-' + groupIdx + '-' + idx"
                        />
                      </template>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="table-footer-user-info">
                <div class="logo">
                  <img :src="require('@/assets/images/logo.png')" alt="Logo" />
                </div>
                <div class="user-info">
                  <div class="user-name">
                    <span>{{ t.contact }} </span>
                    <span style="font-weight: bold">{{ headerInput3 }}</span>
                    <span>{{ t.department }}</span>
                  </div>
                  <div class="user-phone">
                    <img src="@/assets/icons/phone.svg" alt="Phone Icon" />
                    <span style="color: red; font-weight: bold">{{
                      headerInput5_1
                    }}</span>
                  </div>
                  <div class="user-email">
                    <img
                      src="@/assets/icons/mail.svg"
                      alt="Email Icon"
                      style="margin-top: 3px"
                    />
                    <span>{{ headerInput5_2 }}</span>
                  </div>
                  <div class="user-website">
                    <img src="@/assets/icons/building.svg" alt="Website Icon" />
                    <span>{{ headerInput5_3 }}</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- Footer Section -->
            <div
              class="quote-image-page"
              ref="footerSection"
              style="height: auto"
            >
              <img
                :src="images.footer"
                alt="Footer"
                style="
                  width: 100%;
                  height: auto;
                  display: block;
                  margin: 0 auto;
                "
              />
            </div>
          </div>
          <div
            class="action-buttons-column d-flex flex-column align-items-center justify-content-center"
          >
            <label style="align-self: flex-start">USD/VND</label>
            <input v-model="currency" class="w-100" @input="onRateInput" />
            <small
              class="rate-info"
              :class="{ 'rate-warning': rateWarning }"
              :title="rateLabel"
              >{{ rateLabel }}</small
            >
            <button
              class="common-btn delete-btn my-2 w-100"
              @click="revertTableStep"
              :disabled="tableHistory.length < 2"
            >
              Hoàn tác
            </button>
            <button
              class="common-btn delete-btn my-2 w-100"
              @click="revertChanges"
            >
              Đặt lại
            </button>
            <button class="clear-btn my-2 w-100" @click="cancelEdit">
              Hủy
            </button>
            <!-- <SearchUserSaveQuote @user-selected="exportFileCsv" /> -->
            <button
              class="common-btn my-2 w-100 export-btn"
              :disabled="!!exporting"
              @click="exportFileCsv()"
            >
              <b-icon
                :icon="
                  exporting === 'pdf' ? 'arrow-repeat' : 'file-earmark-pdf'
                "
                :animation="exporting === 'pdf' ? 'spin' : null"
              />
              Lưu PDF
            </button>
            <button
              class="common-btn my-2 w-100 export-btn"
              :disabled="!!exporting"
              @click="exportXlsx()"
            >
              <b-icon
                :icon="
                  exporting === 'xlsx' ? 'arrow-repeat' : 'file-earmark-excel'
                "
                :animation="exporting === 'xlsx' ? 'spin' : null"
              />
              Xuất Excel
            </button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { getUsdVndRate } from "@/ultils/quote/exchangeRate";
import {
  QUOTE_LANGS,
  QUOTE_MESSAGES,
  QUOTE_IMAGES,
  getQuoteMessages,
} from "@/ultils/quote/quoteI18n";
import { QUOTE_ROWS } from "@/ultils/quote/quoteRows";
import { exportQuoteXlsx } from "@/ultils/quote/exportQuoteXlsx";
import {
  hasVietnamese,
  translateProduct,
} from "@/ultils/quote/translateQuoteData";

// Cover title: largest font (px) at which every line fits its box
const COVER_TITLE_MAX_PX = 30;
const COVER_TITLE_MIN_PX = 16;

// Is value one of the per-language defaults for this message key?
const isLangDefault = (key, value) =>
  !value ||
  Object.values(QUOTE_MESSAGES).some(
    (m) =>
      (typeof m[key] === "function" ? m[key](new Date()) : m[key]) === value
  );
// import SearchUserSaveQuote from "./SearchUserSaveQuote.vue";

export default {
  name: "BulkEditQuoteModal",
  props: {
    products: {
      type: Array,
      required: true,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      lang: null, // "vi" | "en", chosen in the language modal on open
      langOptions: QUOTE_LANGS,
      hiddenRows: [], // QUOTE_ROWS keys removed by the user
      editProducts: [],
      originalProducts: [],
      editingCell: {}, // {rowKey: {groupIdx: {colIdx: true}}}
      areaInputStrings: [], // Array of arrays: [[string, ...], ...]
      tableHistory: [], // for global table undo
      headerInput1: "To: ",
      headerInput2: "TP.HCM, Ngày Tháng Năm ",
      headerInput3: "",
      headerInput4: "Sale Department",
      headerInput5_1: "",
      headerInput5_2: "",
      headerInput5_3: "",
      headerInput5_4: "",
      bodyInputWebsite: "Galaxyoffice.vn",
      isSubmitted: false,
      currentFloor: [],
      availableTime: [],
      notedArray: [],
      currency: 0,
      rateInfo: null, // { rate, source, date, stale } | { manual: true } | null
      rateLoading: false,
      exporting: null, // "pdf" | "xlsx" while a file is being generated
      coverTitleSize: COVER_TITLE_MAX_PX,
      coverContactFields: [
        {
          key: "headerInput5_1",
          icon: require("@/assets/icons/phone.svg"),
          placeholder: "phonePlaceholder",
          red: true,
        },
        {
          key: "headerInput5_2",
          icon: require("@/assets/icons/mail.svg"),
          placeholder: "emailPlaceholder",
        },
        {
          key: "headerInput5_3",
          icon: require("@/assets/icons/map.svg"),
          placeholder: "websitePlaceholder",
        },
        {
          key: "headerInput5_4",
          icon: require("@/assets/icons/building.svg"),
          placeholder: "addressPlaceholder",
        },
      ],
    };
  },
  computed: {
    ...mapGetters("customer", ["getMemberInfo", "isAdmin"]),
    t() {
      return getQuoteMessages(this.lang);
    },
    images() {
      return QUOTE_IMAGES[this.lang] || QUOTE_IMAGES.vi;
    },
    rateWarning() {
      return (
        !this.rateLoading &&
        (!Number(this.currency) || (this.rateInfo && this.rateInfo.stale))
      );
    },
    rateLabel() {
      const info = this.rateInfo;
      if (this.rateLoading) return "Đang lấy tỷ giá...";
      if (info && info.manual) {
        return Number(this.currency) ? "Nhập tay" : "Vui lòng nhập tỷ giá";
      }
      if (!info) return "Không lấy được tỷ giá, vui lòng nhập";
      const date = info.date ? info.date.split("-").reverse().join("/") : "";
      return `${info.source} ${date}${info.stale ? " (tỷ giá cũ)" : ""}`;
    },
    visibleRows() {
      return QUOTE_ROWS.filter((row) => !this.hiddenRows.includes(row.key));
    },
    productGroups() {
      const groups = [];
      for (let i = 0; i < this.editProducts.length; i += 5) {
        const group = this.editProducts.slice(i, i + 5);
        groups.push(group.concat(Array(5 - group.length).fill(null)));
      }
      return groups.length ? groups : [Array(5).fill(null)];
    },
    headerInput5Formatted() {
      return this.headerInput5
        .replace(/\n/g, "<br>")
        .replace(/ /g, "&nbsp;")
        .replace(/,/g, ",&nbsp;");
    },
  },
  watch: {
    products: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val && val.length) {
          this.editProducts = val.map((p) => JSON.parse(JSON.stringify(p)));
          this.originalProducts = val.map((p) => JSON.parse(JSON.stringify(p)));
          this.tableHistory = [];
          this.pushTableHistory();
          this.applyLanguageToProducts();
          this.currentFloor = [];
          this.availableTime = [];
          this.notedArray = [];
          this.hiddenRows = [];
          val.forEach(() => {
            this.currentFloor.push(this.t.defaultFloor);
            this.availableTime.push(this.t.defaultVacantTime);
            this.notedArray.push("   ");
          });
        }
      },
    },
    visible(val) {
      if (!val) this.lang = null;
      if (val) {
        this.hiddenRows = [];
        this.editProducts = this.products.map((p) =>
          JSON.parse(JSON.stringify(p))
        );
        this.originalProducts = this.products.map((p) =>
          JSON.parse(JSON.stringify(p))
        );
        this.tableHistory = [];
        this.pushTableHistory();
      }
    },
    productGroups: {
      handler(val) {
        // Sync areaInputStrings with product groups
        this.areaInputStrings = val.map((group) =>
          group.map((p) =>
            p && p.product_detail
              ? (p.product_detail.empty_area || []).join(", ")
              : ""
          )
        );
      },
      immediate: true,
      deep: true,
    },
    getMemberInfo: {
      handler(val) {
        this.headerInput2 = this.t.formatDate(new Date());
        this.headerInput3 = val.name || "";
        this.headerInput5_1 = val.phone || "";
        this.headerInput5_2 = val.username || "";
        this.headerInput5_3 = "galaxyoffice.vn";
        this.headerInput5_4 = this.t.defaultCompanyAddress;
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.loadExchangeRate();
  },
  mounted() {
    this.$nextTick(this.setDynamicRowHeights);
  },
  updated() {
    this.$nextTick(() => {
      this.setDynamicRowHeights();
      this.fitCoverTitle();
    });
  },
  methods: {
    selectLang(lang) {
      this.lang = lang;
      this.applyLanguageDefaults();
      this.applyLanguageToProducts();
      // the first attempt (on page load) may have failed: retry on open
      if (!Number(this.currency)) this.loadExchangeRate();
    },
    onLangModalHide() {
      // Closed without picking a language -> cancel the whole flow
      if (!this.lang) this.$emit("close");
    },
    // Swap texts that still hold a language default; keep what the user typed
    applyLanguageDefaults() {
      if (isLangDefault("formatDate", this.headerInput2)) {
        this.headerInput2 = this.t.formatDate(new Date());
      }
      if (isLangDefault("defaultCompanyAddress", this.headerInput5_4)) {
        this.headerInput5_4 = this.t.defaultCompanyAddress;
      }
      this.currentFloor = this.currentFloor.map((v) =>
        isLangDefault("defaultFloor", v) ? this.t.defaultFloor : v
      );
      this.availableTime = this.availableTime.map((v) =>
        isLangDefault("defaultVacantTime", v) ? this.t.defaultVacantTime : v
      );
    },
    // English quote: translate the data cells (address, structure, fees, ...)
    // of the working copy once; the products in the CRM are not touched.
    // Undo history restarts here so undo never brings the vietnamese back.
    applyLanguageToProducts() {
      if (this.lang !== "en") return;
      this.editProducts = this.editProducts.map(translateProduct);
      this.tableHistory = [];
      this.pushTableHistory();
    },
    // Cells of an english quote still holding vietnamese words are marked
    // on screen for the sales person to fix; never in the exported files.
    isUntranslated(row, ctx) {
      if (this.lang !== "en" || this.isSubmitted) return false;
      return hasVietnamese(String(row.display(ctx)));
    },
    // Shrinks the cover title until its longest line fits (translations
    // differ in length; an overflowing line also confuses html2canvas,
    // which then drops the spaces between words in the PDF)
    fitCoverTitle() {
      const box = this.$refs.coverTitle;
      if (!box || !box.clientWidth) return;
      const lines = Array.from(box.children);
      let size = COVER_TITLE_MAX_PX;
      box.style.fontSize = size + "px";
      while (
        size > COVER_TITLE_MIN_PX &&
        lines.some((line) => line.scrollWidth > box.clientWidth)
      ) {
        size -= 1;
        box.style.fontSize = size + "px";
      }
      if (size !== this.coverTitleSize) this.coverTitleSize = size;
    },
    cellCtx(product, groupIdx, idx) {
      return {
        vm: this,
        product,
        groupIdx,
        idx,
        globalIdx: groupIdx * 5 + idx,
      };
    },
    commitEdit(row, groupIdx, idx) {
      if (row.commit) row.commit(this.cellCtx(null, groupIdx, idx));
      else this.stopEdit(row.key, groupIdx, idx);
    },
    onHeaderInput1Input(e) {
      // Auto-resize textarea to fit content, but max 2 lines
      const textarea = e.target;
      textarea.rows = textarea.value.includes("\n") ? 2 : 1;
    },
    async loadExchangeRate() {
      if (this.rateLoading) return;
      this.rateLoading = true;
      try {
        const result = await getUsdVndRate();
        // keep a rate the user typed while the request was running
        if (this.rateInfo && this.rateInfo.manual) return;
        this.rateInfo = result;
        if (result) this.currency = result.rate;
      } finally {
        this.rateLoading = false;
      }
    },
    onRateInput() {
      this.rateInfo = { manual: true };
    },
    getProductImage(product) {
      if (product.image && product.image.filename) {
        return (
          process.env.VUE_APP_ORIGIN_API_URL +
          `/files/product?filename=${product.image.filename}&product_id=${product.id}`
        );
      }
      return require("@/assets/images/logo4_3.png");
    },
    convertToString(value) {
      return !value || value?.length === 0 ? "" : value.join(", ");
    },
    revertChanges() {
      this.editProducts = this.originalProducts.map((p) =>
        JSON.parse(JSON.stringify(p))
      );
      this.hiddenRows = [];
      this.applyLanguageToProducts();
    },
    cancelEdit() {
      this.$emit("close");
    },
    // openSearchUserModal() {
    //   this.$refs.modalBulkEditQuote.show();
    // },
    // ...existing code...
    getDomEl(ref) {
      if (!ref) return null;
      if (Array.isArray(ref)) ref = ref[0];
      if (ref && ref.$el) return ref.$el;
      return ref instanceof Element ? ref : null;
    },
    // Switch the preview to read-only mode (no inputs/remove buttons) and
    // collect the page elements: cover, one per product table, footer.
    async preparePagesForCapture(type) {
      this.exporting = type;
      this.isSubmitted = true;
      this.setDynamicRowHeights();
      await this.$nextTick();
      await new Promise((resolve) => setTimeout(resolve, 400));

      const headerEl = this.getDomEl(this.$refs.headerSection);
      const footerEl = this.getDomEl(this.$refs.footerSection);
      const tableEls = [];
      for (let i = 0; ; i++) {
        const el = this.getDomEl(this.$refs[`listTable-${i}`]);
        if (!el) break;
        tableEls.push(el);
      }
      if (!headerEl || !footerEl || tableEls.length === 0) return null;
      return { headerEl, footerEl, tableEls };
    },
    finishCapture() {
      this.exporting = null;
      this.isSubmitted = false;
      this.setDynamicRowHeights();
    },
    // Renders a page element off-screen with html2canvas. With collectLinks,
    // also returns the boxes of the "LINK WEBSITE" cells (CSS px).
    async renderElementToCanvas(el, { scale = 3, collectLinks = false } = {}) {
      // Clone as-is, off-screen but visible so it keeps its layout
      const clone = el.cloneNode(true);
      clone.style.position = "absolute";
      clone.style.left = "-99999px";
      clone.style.top = "0";
      clone.style.zIndex = "-1";
      clone.style.background = window.getComputedStyle(el).background || "#fff";
      clone.style.width = el.offsetWidth ? el.offsetWidth + "px" : "1010px";
      clone.style.height = el.offsetHeight ? el.offsetHeight + "px" : "auto";
      document.body.appendChild(clone);

      try {
        // measure and draw with the real font, not a fallback
        if (document.fonts && document.fonts.ready) await document.fonts.ready;
        await Promise.all(
          Array.from(clone.querySelectorAll("img")).map((img) =>
            img.complete
              ? Promise.resolve()
              : new Promise((resolve) => {
                  img.onload = img.onerror = resolve;
                })
          )
        );
        await new Promise((resolve) => setTimeout(resolve, 100));

        const links = [];
        if (collectLinks) {
          const cloneRect = clone.getBoundingClientRect();
          // Only the dedicated "LINK WEBSITE" cells, so any URL works
          // (even without an http/www prefix, e.g. "galaxyoffice.vn")
          clone.querySelectorAll(".website-link-cell").forEach((cell) => {
            const text = cell.textContent.trim();
            if (!text) return;
            const rect = cell.getBoundingClientRect();
            links.push({
              text,
              x: rect.left - cloneRect.left,
              y: rect.top - cloneRect.top,
              width: rect.width,
              height: rect.height,
              cloneWidth: cloneRect.width,
              cloneHeight: cloneRect.height,
            });
          });
        }

        const canvas = await html2canvas(clone, {
          backgroundColor: "#fff",
          scale,
          useCORS: true,
          logging: false,
          removeContainer: true,
        });
        return { canvas, links };
      } finally {
        document.body.removeChild(clone);
      }
    },
    async exportFileCsv() {
      if (this.exporting) return;
      const pages = await this.preparePagesForCapture("pdf");
      if (!pages) {
        alert("Không tìm thấy đủ nội dung để xuất PDF. Vui lòng thử lại.");
        this.finishCapture();
        return;
      }

      // Render a page element to canvas and add it to the PDF
      const renderToPdfPage = async (el, pdf, addPage, collectLinks) => {
        const { canvas, links } = await this.renderElementToCanvas(el, {
          collectLinks,
        });
        const imgData = canvas.toDataURL("image/jpeg", 1.0);
        if (addPage) pdf.addPage();
        // PDF page size in mm (A4 landscape)
        const pdfWidth = 297;
        const pdfHeight = 210;
        // Image size in mm
        const pxPerMm = 96 / 25.4;
        const imgWidth = canvas.width / pxPerMm;
        const imgHeight = canvas.height / pxPerMm;
        // Always fill width, scale height proportionally
        let renderWidth = pdfWidth;
        let renderHeight = (imgHeight * pdfWidth) / imgWidth;
        let x = 0;
        let y = 0;
        // If height overflows, fit by height instead
        if (renderHeight > pdfHeight) {
          renderHeight = pdfHeight;
          renderWidth = (imgWidth * pdfHeight) / imgHeight;
          x = (pdfWidth - renderWidth) / 2;
        } else {
          y = (pdfHeight - renderHeight) / 2;
        }
        pdf.addImage(imgData, "JPEG", x, y, renderWidth, renderHeight);

        // Add clickable links to PDF for website URLs.
        // link.* and clone* are CSS px from getBoundingClientRect, so use the
        // clone's CSS size as the denominator to map into the rendered mm box.
        links.forEach((link) => {
          let url = link.text.trim();
          if (!url.startsWith("http://") && !url.startsWith("https://")) {
            url = "https://" + url;
          }
          pdf.link(
            x + (link.x / link.cloneWidth) * renderWidth,
            y + (link.y / link.cloneHeight) * renderHeight,
            (link.width / link.cloneWidth) * renderWidth,
            (link.height / link.cloneHeight) * renderHeight,
            { pageNumber: pdf.getNumberOfPages(), url }
          );
        });
      };

      const pdf = new jsPDF({
        unit: "mm",
        format: "a4",
        orientation: "landscape",
      });

      try {
        // 1. Header page
        await renderToPdfPage(pages.headerEl, pdf, false, false);
        // 2. Each product table as a page
        for (const tableEl of pages.tableEls) {
          await renderToPdfPage(tableEl, pdf, true, true);
        }
        // 3. Footer page
        await renderToPdfPage(pages.footerEl, pdf, true, false);
        pdf.save(`${this.t.fileName}_${this.lang.toUpperCase()}.pdf`);
      } catch (err) {
        alert("Có lỗi khi xuất PDF: " + err.message);
        console.error("PDF export error:", err);
      } finally {
        this.finishCapture();
      }
    },
    async exportXlsx() {
      if (this.exporting) return;
      const pages = await this.preparePagesForCapture("xlsx");
      if (!pages) {
        alert("Không tìm thấy đủ nội dung để xuất Excel. Vui lòng thử lại.");
        this.finishCapture();
        return;
      }
      try {
        // The cover keeps its look (background art + overlaid texts) as a
        // picture; the product tables are written as real, editable cells.
        const { canvas } = await this.renderElementToCanvas(pages.headerEl, {
          scale: 2,
        });
        await exportQuoteXlsx({
          t: this.t,
          groups: this.productGroups,
          rows: this.visibleRows,
          ctxFor: this.cellCtx,
          contact: {
            name: this.headerInput3,
            phone: this.headerInput5_1,
            email: this.headerInput5_2,
            website: this.headerInput5_3,
          },
          rate: this.currency,
          coverCanvas: canvas,
          footerUrl: this.images.footer,
          logoUrl: require("@/assets/images/logo.png"),
          productImage: this.getProductImage,
          fallbackImageUrl: require("@/assets/images/logo4_3.png"),
          fileName: `${this.t.fileName}_${this.lang.toUpperCase()}.xlsx`,
        });
      } catch (err) {
        alert("Có lỗi khi xuất Excel: " + err.message);
        console.error("XLSX export error:", err);
      } finally {
        this.finishCapture();
      }
    },
    // removed duplicate/old code after refactor
    // ...existing code...
    getFullAddress(address) {
      const parts = [address.detail, address.ward, address.district]
        .filter(Boolean)
        .join(", ");
      return parts;
    },
    isEditing(rowKey, groupIdx, idx) {
      return (
        this.editingCell[rowKey] &&
        this.editingCell[rowKey][groupIdx] &&
        this.editingCell[rowKey][groupIdx][idx]
      );
    },
    startEdit(rowKey, groupIdx, idx) {
      if (!this.editingCell[rowKey]) {
        this.$set(this.editingCell, rowKey, {});
      }
      if (!this.editingCell[rowKey][groupIdx]) {
        this.$set(this.editingCell[rowKey], groupIdx, {});
      }
      this.$set(this.editingCell[rowKey][groupIdx], idx, true);
      this.$nextTick(() => {
        const refName = `input-${rowKey}-${groupIdx}-${idx}`;
        let input = this.$refs[refName];
        if (Array.isArray(input)) input = input[0];
        if (input) {
          input.focus();
          input.select && input.select();
        } else {
          setTimeout(() => {
            let input2 = this.$refs[refName];
            if (Array.isArray(input2)) input2 = input2[0];
            if (input2) {
              input2.focus();
              input2.select && input2.select();
            }
          }, 50);
        }
      });
    },
    stopEdit(rowKey, groupIdx, idx) {
      if (this.editingCell[rowKey] && this.editingCell[rowKey][groupIdx]) {
        this.$set(this.editingCell[rowKey][groupIdx], idx, false);
      }
      this.pushTableHistory();
    },
    pushTableHistory() {
      const last = this.tableHistory[this.tableHistory.length - 1];
      const current = JSON.stringify(this.editProducts);
      if (!last || JSON.stringify(last) !== current) {
        this.tableHistory.push(JSON.parse(current));
        if (this.tableHistory.length > 5) this.tableHistory.shift();
      }
    },
    onAreaDetailBlur(groupIdx, idx) {
      const product = this.productGroups[groupIdx][idx];
      if (product && product.product_detail) {
        product.product_detail.empty_area = (
          this.areaInputStrings[groupIdx][idx] || ""
        )
          .split(",")
          .map((s) => s.trim())
          .filter(Boolean);
        this.$set(
          this.areaInputStrings[groupIdx],
          idx,
          product.product_detail.empty_area.join(", ")
        );
        this.pushTableHistory();
      }
      this.stopEdit("empty_area_detail", groupIdx, idx);
    },
    removeTableRow(rowKey) {
      if (!this.hiddenRows.includes(rowKey)) this.hiddenRows.push(rowKey);
      this.$nextTick(this.setDynamicRowHeights);
    },
    setDynamicRowHeights(totalHeight = 628) {
      // if (this.isSubmitted) totalHeight = 700; // Adjust height for submitted state
      // console.log("Setting dynamic row heights with totalHeight:", totalHeight);
      const tables = Object.keys(this.$refs)
        .filter((key) => key.startsWith("editableTable-"))
        // a removed table leaves an empty [] ref behind
        .map((key) => this.getDomEl(this.$refs[key]));
      tables.forEach((table) => {
        if (!table) return;
        const dataRows = Array.from(
          table.querySelectorAll("tbody tr:not(.product-image)")
        );
        if (!dataRows.length) return;
        const IMAGE_ROW_HEIGHT = 143; // Height of the image row + header
        const availableHeight = totalHeight - IMAGE_ROW_HEIGHT;
        let totalPoints = 0;
        const rowPoints = dataRows.map((row) => {
          if (row.classList.contains("two-line-row")) return 2;
          if (row.classList.contains("one-line-row")) return 1;
          return 1;
        });
        totalPoints = rowPoints.reduce((a, b) => a + b, 0);
        const heightPerPoint = availableHeight / totalPoints;
        console.log(
          "Total points:",
          totalPoints,
          "Height per point:",
          heightPerPoint
        );
        const dataHeader = Array.from(table.querySelectorAll("thead tr"));
        let headerHeight =
          20 + availableHeight - totalPoints * Math.floor(heightPerPoint); // Fixed height for header rows
        dataHeader.forEach((headerRow) => {
          headerRow.style.height = headerHeight + "px"; // Set a fixed height for header rows
          headerRow.style.minHeight = headerHeight + "px";
          headerRow.style.maxHeight = headerHeight + "px";
        });
        console.log(
          "Header height set to:",
          headerHeight,
          "px for each header row"
        );
        // Set heights for data rows
        dataRows.forEach((row, idx) => {
          const points = rowPoints[idx];
          const rowHeight = Math.floor(points * heightPerPoint);
          row.style.height = rowHeight + "px";
          row.style.minHeight = rowHeight + "px";
          row.style.maxHeight = rowHeight + "px";
        });
      });
    },
    revertTableStep() {
      if (this.tableHistory.length < 2) return;
      this.tableHistory.pop();
      const prev = this.tableHistory[this.tableHistory.length - 1];
      if (prev) {
        this.editProducts = JSON.parse(JSON.stringify(prev));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variable.scss";
// Header like the other modals (MemberInfoModal): red banner, white title
.quote-modal-header {
  position: relative;
  text-align: center;
  background: rgba($primary-color, 0.65);
  color: white;
  padding: 15px 48px;
  font-size: 18px;
  font-weight: bold;
  text-transform: uppercase;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  .quote-modal-close {
    position: absolute;
    top: 50%;
    right: 12px;
    transform: translateY(-50%);
    width: 32px;
    height: 32px;
    padding: 0;
    border: none;
    border-radius: 50%;
    background: transparent;
    color: white;
    font-size: 26px;
    line-height: 32px;
    cursor: pointer;
    &:hover {
      background: rgba(255, 255, 255, 0.2);
    }
  }
}
.bulk-edit-quote-modal {
  display: flex;
  flex-direction: column;
  max-height: 80vh;
  overflow-y: auto;
  padding: 16px 0;
}

.table-responsive {
  flex-grow: 1;
  gap: 10px;
}

.quote-table-product {
  border: solid 1px #cbced1;
}

.table-footer-user-info {
  text-align: center;
  display: flex;
  justify-content: space-between;
  height: 40px;
  border-radius: 4px;
  margin-top: 6px;
  gap: 16px;
  .logo {
    height: 100%;
    width: auto;
    padding: 4px 11px;
    border: solid 1px #cbced1;
    border-radius: 4px;
    display: flex;
    img {
      height: 100%;
      width: auto;
    }
  }
  .user-info {
    flex-grow: 1;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    border: solid 1px #cbced1;
    border-radius: 4px;
    padding: 3px;
    padding-right: 32px;
    font-size: 11px;
    .user-name {
      display: flex;
      flex-direction: column;
      span {
        line-height: 11px;
        text-align: left;
      }
    }
    .user-phone,
    .user-email,
    .user-website {
      display: flex;
      align-items: center;
      img {
        margin-right: 4px;
      }
      span {
        line-height: 11px;
        text-align: left;
      }
    }
    img {
      width: 20px;
      height: auto;
    }
  }
}
.product-image {
  height: 120px !important;
}
.product-image td {
  height: 120px !important;
  min-height: 120px !important;
  max-height: 120px !important;
  vertical-align: middle;
  padding: 0;
}

/* --- HEIGHT CONTROL: DYNAMIC HEIGHTS FOR ALL ROWS --- */
.table-responsive.flex-grow-1 {
  height: 714px;
  padding: 16px;
  border: solid 1px #cbced1;
  display: flex;
  flex-direction: column;
}
.table-editable {
  table-layout: fixed;
  background: #fff;
  margin-bottom: 0;
  width: 100%;
  .high-light td {
    background: #eb1e2726;
    font-weight: bold;
  }
}
.table-editable tbody {
  /* Remove flex, use default table layout for column alignment */
  height: 100%;
}
.table-editable tbody tr.product-image {
  height: 120px !important;
  max-height: 120px !important;
  min-height: 120px !important;
}
.table-editable th,
.table-editable td {
  vertical-align: middle;
}
.table-editable tbody tr {
  position: relative;
}
.remove-btn {
  position: absolute;
  top: 50%;
  left: -16px;
  transform: translateY(-50%);
  z-index: 2;
  width: 15px;
  height: 15px !important;
  cursor: pointer;
}
.text-hint {
  font-size: 8px;
  font-weight: normal;
}
.d-flex.flex-row.align-items-stretch {
  width: 100%;
  min-width: 700px;
  margin: 0 auto;
  display: flex;
  padding: 0 10px;
  justify-content: space-between;
}
.table-responsive.flex-grow-1 {
  width: 100%;
  max-width: 1010px !important;
  min-width: 700px;
  height: 714px;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
}
.action-buttons-column {
  min-height: 100%;
  padding: 0;
  flex: 0 0 130px;
  width: 130px;
}
.action-buttons-column button {
  width: 100%;
  margin: 0 0 8px 0;
  padding: 8px 10px;
  white-space: nowrap;
  justify-content: center;
  align-items: center;
}
.table-editable th,
.table-editable td {
  /* No width changes here, only height/vertical */
  word-break: break-word;
  text-align: center;
  vertical-align: middle;
  line-height: unset;
  padding: 2px;
  font-size: 10px;
  border: 1px solid #a7a7a7;
}
.table-editable td input {
  font-size: 9px;
}
.table-editable th {
  background: #f5f5f5;
  font-weight: bold;
}
.table-editable td:first-child {
  font-size: 9px;
  font-weight: bold;
  text-align: left;
}
.table-editable input {
  min-width: 100px;
  font-size: 13px;
  width: 100%;
  box-sizing: border-box;
}
.table-editable img {
  display: block;
  margin: 0 auto;
  height: 100%;
  padding: 2px;
}
.editable-span {
  cursor: pointer;
  display: block;
  border-radius: 3px;
  transition: background 0.15s;
  min-height: 15px;
}
.text-truncate-table {
  font-size: 7px;
}
.editable-span:hover {
  background: #f0f4fa;
  color: #007bff;
}
// english quote: this cell still has vietnamese words (screen only)
.editable-span.quote-cell-untranslated {
  background: #fff3b0;
  box-shadow: inset 0 0 0 1px #f0c419;
}
.quote-image-page {
  height: 100%;
  border: solid 1px #cbced1;
  .header-content-bg {
    position: absolute;
    top: 260px;
    right: 50px;
    width: 450px;
    .header-content {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .title-header {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        font-weight: bold;
        line-height: 1.3;
        color: $primary-color;
        span {
          white-space: nowrap;
        }
      }

      .header-abs-input-1 {
        width: 300px;
        z-index: 2;
        text-align: center;
        font-weight: bold;
        font-size: 24px;
      }
      .header-abs-input-2 {
        width: 300px;
        z-index: 2;
        text-align: center;
      }
    }
  }
  .header-abs-input {
    font-size: 14px;
    border-radius: 4px;
    background: transparent;
    padding: 2px;
  }
  input {
    border: solid 1px #aaaaaa;
  }
  .cover-contact {
    position: absolute;
    left: 41%;
    bottom: 30px;
    width: 340px;
    z-index: 2;
    display: flex;
    flex-direction: column;
    gap: 3px;
    font-size: 14px;
    line-height: 18px;
    input {
      width: 100%;
      padding: 1px 4px;
      border-radius: 4px;
      background: transparent;
      font-size: inherit;
      font-weight: inherit;
      color: inherit;
    }
    .cover-contact-name {
      font-size: 20px;
      font-weight: bold;
      line-height: 26px;
    }
    .cover-contact-dept {
      margin-bottom: 4px;
    }
    .cover-contact-row {
      display: flex;
      align-items: flex-start;
      gap: 6px;
      img {
        width: 20px;
        height: 18px;
        flex-shrink: 0;
      }
    }
    &.editing .cover-contact-row {
      align-items: center;
    }
  }
  .red-input {
    color: rgb(255, 35, 35);
  }
}
.common-btn img {
  margin-left: 0px;
}
.rate-info {
  align-self: flex-start;
  font-size: 11px;
  line-height: 1.2;
  color: #6c757d;
  margin: 2px 0 6px;
}
.rate-warning {
  color: #dc3545;
  font-weight: bold;
}
// Same look as the other modals (MemberInfoModal): red banner header
.quote-lang-modal {
  .quote-lang-header {
    text-align: center;
    background: rgba($primary-color, 0.65);
    color: white;
    padding: 15px 0;
    font-size: 18px;
    font-weight: bold;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
  }
  .quote-lang-body {
    padding: 24px 24px 8px;
  }
  .quote-lang-question {
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 20px;
  }
  .quote-lang-options {
    display: flex;
    gap: 16px;
  }
  .quote-lang-option {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    padding: 18px 12px;
    background: #fff;
    border: 1px solid #cbced1;
    border-radius: 6px;
    cursor: pointer;
    transition: border-color 0.15s, box-shadow 0.15s, background 0.15s;
    &:hover,
    &:focus-visible {
      outline: none;
      border-color: $primary-color;
      background: rgba($primary-color, 0.04);
      box-shadow: 0 2px 8px rgba($primary-color, 0.2);
    }
  }
  .quote-lang-code {
    width: 44px;
    height: 44px;
    line-height: 44px;
    border-radius: 50%;
    background: $secondary-color;
    color: #fff;
    font-weight: bold;
    font-size: 15px;
  }
  .quote-lang-option:hover .quote-lang-code {
    background: $primary-color;
  }
  .quote-lang-label {
    margin-top: 6px;
    font-size: 17px;
    font-weight: bold;
    color: #212529;
  }
  .quote-lang-hint {
    font-size: 13px;
    color: #6c757d;
  }
  .quote-lang-footer {
    display: flex;
    justify-content: flex-end;
    padding: 16px 24px 20px;
    .clear-btn {
      height: 40px;
      min-width: 90px;
      justify-content: center;
      align-items: center;
    }
  }
}
.export-btn {
  gap: 8px;
  font-size: 15px;
  .b-icon {
    font-size: 20px;
    flex-shrink: 0;
  }
  &:disabled {
    opacity: 0.65;
    cursor: not-allowed;
  }
}
</style>

<style lang="scss">
// b-modal renders into <body>, outside #app, so its content would get
// bootstrap's "system-ui" font. html2canvas cannot draw system-ui on the
// canvas (it falls back to a wider font and words overlap: "SUMMARYOF" in
// the PDF), so use the app font explicitly. The PDF pages carry it
// themselves because they are cloned to <body> before being captured.
#modal-bulk-edit-quote,
#modal-quote-lang,
.quote-image-page,
.quote-table-product {
  font-family: "Roboto", Arial, sans-serif;
}

// The dialog element is rendered by b-modal (outside the scoped styles).
// 30px wider than bootstrap's xl (1140px) for the wider action column, so
// the preview pages (captured for the PDF) keep exactly their previous width.
@media (min-width: 1200px) {
  .modal-dialog.modal-xl.quote-edit-dialog {
    max-width: 1170px;
  }
}
</style>
